(function () {
	'use strict';

	// ─── Practice areas nav (Arelis Practice Areas Nav widget) ──────────────────
	// Native scrolling list with a custom 4 px track: the thumb's size and offset
	// follow the viewport. "Keri nimekirja" scrolls one view down and fades out at
	// the end. The current area is scrolled into view on load.

	function initNav(nav) {
		if (nav.dataset.ready || !nav.classList.contains('is-scrollable')) {
			return;
		}
		nav.dataset.ready = '1';

		var viewport = nav.querySelector('.arelis-practice-nav__viewport');
		var track = nav.querySelector('.arelis-practice-nav__track');
		var thumb = nav.querySelector('.arelis-practice-nav__thumb');
		var hint = nav.querySelector('.arelis-practice-nav__hint');

		function update() {
			var visible = viewport.clientHeight;
			var total = viewport.scrollHeight;
			var scrollable = total - visible;

			if (scrollable <= 1) {
				nav.classList.add('is-at-end');
				if (track) {
					track.hidden = true;
				}
				return;
			}
			if (track) {
				track.hidden = false;
			}

			var trackHeight = track ? track.clientHeight : visible;
			var thumbHeight = Math.max(32, trackHeight * visible / total);
			var offset = (trackHeight - thumbHeight) * (viewport.scrollTop / scrollable);
			if (thumb) {
				thumb.style.setProperty('--thumb-height', thumbHeight + 'px');
				thumb.style.setProperty('--thumb-offset', offset + 'px');
			}
			nav.classList.toggle('is-at-end', viewport.scrollTop >= scrollable - 2);
		}

		viewport.addEventListener('scroll', update, { passive: true });
		window.addEventListener('resize', update);

		if (hint) {
			hint.addEventListener('click', function () {
				viewport.scrollBy({ top: viewport.clientHeight * 0.8, behavior: 'smooth' });
			});
		}

		var active = viewport.querySelector('.is-active');
		if (active) {
			viewport.scrollTop = Math.max(0, active.offsetTop - viewport.clientHeight / 3);
		}

		update();
	}

	function initAll(scope) {
		Array.prototype.forEach.call((scope || document).querySelectorAll('.arelis-practice-nav'), initNav);
	}

	document.addEventListener('DOMContentLoaded', function () {
		initAll();
	});

	window.addEventListener('elementor/frontend/init', function () {
		window.elementorFrontend.hooks.addAction('frontend/element_ready/arelis_practice_nav.default', function ($scope) {
			initAll($scope[0]);
		});
	});

})();
